// extracted by mini-css-extract-plugin
export default {"layer":"SoilLayer_layer__SgN3e","hiddenLayer":"SoilLayer_hiddenLayer__bJ04k"};